import { connect } from 'react-redux';
import { userSubmitNotificationsForm } from 'store/actionCreators/user';

import { getUserProfileEmailNotifications, getUserProfileEmail } from 'store/selectors/user';

import NotificationSettings from 'components/NotificationSettings';

const mapStateToProps = state => {
  const isEmail = !!getUserProfileEmail(state);
  return {
    isEmail,
    initialValues: {
      allowEmail: isEmail && getUserProfileEmailNotifications(state),
    },
  };
};

const mapDispatchToProps = {
  onSubmit: userSubmitNotificationsForm,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationSettings);
